<template>
	<div class="text-left blogPostContainer">
		<div class="blogPostCard">
			<div class="blogPost">
				<div class="blogPostDate">{{dateFormatted}}</div>
				<h2 class="blogPostTitle">{{title}}</h2>
				<div class="blogPostMessage1">
					<span v-html="message"></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { utilityService } from '@/services/utilityService';

export default {
	name: 'BlogPost',
	props: {
		title: {
			type: String,
			default: ''
		},
		date: {
			type: String,
			default: ''
		},
		message: {
			type: String,
			default: ''
		}
	},
	computed: {
		dateFormatted: function () {
			return utilityService.formatDate(new Date(this.date));
		}
	}
}
</script>

<style>

</style>
